import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd';

import { Principal } from './principal.service';
import { AuthServerProvider } from './auth-jwt.service';
import { LoginModalComponent } from './login-modal.component';
import { SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { ResetPasswordService } from '../auth/reset-password.service';

@Injectable({ providedIn: 'root' })
export class LoginService {

    private isModalOpened = false;
    qrcodeUrl: any;

    constructor(
        private router: Router,
        private principal: Principal,
        private modalService: NzModalService,
        private authServerProvider: AuthServerProvider,
        private sessionStorage: SessionStorageService,
        private httpClient: HttpClient,
        private resetPasswordService:ResetPasswordService
    ) {

    }

    login(credentials, callback?): Promise<any> {
        const cb = callback || function () { };

        this.authServerProvider.clearAuthenticationToken();
        this.principal.authenticate(null);

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe((data) => {
                this.lazadaDatamoatLogin(credentials, 'success');
                this.principal.identity(true).then((account) => {
                    let host = location.host;
                    if (host.includes('t.wojia-yun.com') || host.includes('localhost')) {
                        if(!account) {
                            this.resetPasswordService.resetPasswordByModal();
                        }
                    }
                    resolve(account);
                });
                return cb();
            }, (err) => {
                this.lazadaDatamoatLogin(credentials, 'fail');
                reject(err);
                return cb(err);
            });
        });
    }

    lazadaDatamoatLogin(account, loginStatus) {
        let host = location.host;
        if (!host.includes('t.wojia-yun.com')) return; 
        let ati = this.getCookie('_ati');
        let entity = {
            ati:ati,
            loginMessage: loginStatus,
            loginResult: loginStatus,
            username: account.username
        }
        this.httpClient.post('/gm-sync-lazada/api/sync/_public/lazada-datamoat-login', entity).subscribe();
    }

    logout() {
        this.authServerProvider.logout().subscribe();
        this.router.navigate(['/login']);
    }

    loginWithToken(jwt, rememberMe) {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    }

    checkLoginForAuthExpired() {
        this.authServerProvider.logout().subscribe();
        setTimeout(() => {
            const skipUrls: any = ['/', '/login', '/activate', '/reset', '/404', '/403'];
            if (!skipUrls.includes(this.router.url)) {
                // if (!this.sessionStorage.retrieve('authenticationToken')) {
                    this.loginByModal();
                // }
            }
        }, 500);
    }

    loginByModal(isWechatLogin?, httpErrorResponse ?) {
        if (this.isModalOpened) { return; }
        this.isModalOpened = true;
        const self = this;
        const currentRouter = this.router.url;
        this.sessionStorage.store('currentRouter', currentRouter);
        this.modalService.create({
            nzWidth: 910,
            nzTitle: null,
            nzClosable: true,
            nzMaskClosable: false,
            nzFooter: null,
            nzContent: LoginModalComponent,
            nzStyle: { 'top': '170px' },
            nzBodyStyle: { 'padding': 0 },
            nzComponentParams: {
                isWechatLogin: isWechatLogin,
                httpErrorResponse : httpErrorResponse ,
                currentRouter: currentRouter,
                loginHandle: (credentials) => { return self.login(credentials); },

            },
            nzOnOk: () => {
                self.isModalOpened = false;
                if (currentRouter.includes('login')) {
                    self.router.navigate(['/apps']);
                } else {
                    self.router.navigate([currentRouter]);
                }
            },
            nzOnCancel: () => {
                self.isModalOpened = false;
                self.router.navigate(['/login']);
            },
        });
    }

    private getCookie(cookieName) {
        let strCookie = document.cookie;
        let arrCookie = strCookie.split("; ");
        for(let i = 0; i < arrCookie.length; i++){
            let arr = arrCookie[i].split("=");
            if(cookieName == arr[0]){
                return arr[1];
            }
        }
        return "";
    }
}
